export default {
  user: {
    access_token: "",
    user_id: "",
  },
};
